import React from "react";
import { connect } from "react-redux";
import AccessExamModal from "../component/AccessExamModal.jsx";
import Ball from "../../../assets/Ball.svg";
import axiosInstance from "../../../store/services/AxiosService";
import { changeStatusEdit } from "../../../store/actions/index";
import moment from "moment";

class AccessList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accessExamModalShow: false,
            selectedScheduleId: null,
            selectedCaseId: null,
            accessData: [],
            loading: true,
        };
    }

    componentDidMount() {
        this.fetchAccessList();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.schoolId !== this.props.schoolId) {
            this.fetchAccessList();
        }
        if (this.props.finishEdit === true) {
            this.props.changeStatusEdit(false);
            this.fetchAccessList();
        }
    }

    fetchAccessList = () => {
        this.setState({ loading: true });
        axiosInstance
            .get(`/schedules/school/${this.props.schoolId}/access-list`)
            .then((response) => {
                this.setState({
                    accessData: response.data || [],
                    loading: false,
                });
            })
            .catch(() => {
                this.setState({ accessData: [], loading: false });
            });
    };

    changeDateFormat = (date) => {
        if (!date) return "-";
        let dateNew = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
        return dateNew;
    };

    changeTimeFormat = (time) => {
        if (!time) return "-";
        let dateNew = moment(time, "HH:mm:ss").format("HH mm");
        let fields = String(dateNew).split(" ");
        return fields[0] + "." + fields[1];
    };

    onClickAccessExam = (apiScheduleId, caseId) => {
        this.setState({
            accessExamModalShow: true,
            selectedScheduleId: apiScheduleId,
            selectedCaseId: caseId,
        });
    };

    render() {
        const { accessData, loading } = this.state;
        const accessExamModalClose = () => {
            this.setState({ accessExamModalShow: false });
            this.fetchAccessList();
        };

        if (loading) {
            return (
                <div className="d-flex justify-content-center">
                    <img src={Ball} className="img-fluid" alt="" />
                </div>
            );
        }

        if (accessData.length === 0) {
            return (
                <div className="text-center py-4">
                    <i className="mdi mdi-key-variant" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                    <p className="mt-2 text-muted">Belum ada jadwal ujian yang terdaftar.</p>
                </div>
            );
        }

        return (
            <div className="table-responsive">
                <table
                    className="table display table-bordered text-center table-hover nowrap"
                    id="dataTable"
                >
                    <thead>
                        <tr>
                            <th style={{ padding: "15px" }}>Mata Pelajaran</th>
                            <th style={{ padding: "15px" }}>Jadwal</th>
                            <th style={{ padding: "15px" }}>Keterangan</th>
                            <th style={{ padding: "15px" }}>Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accessData.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <b style={{ color: "#403f3f" }}>
                                        {item.course_name || `Jadwal #${item.api_schedule_id}`}
                                    </b>
                                </td>
                                <td className="text-left">
                                    <div>
                                        <p className="item-table-dash">
                                            <span className="mdi mdi-calendar-text icon-dash"></span>
                                            {this.changeDateFormat(item.start_date)}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="item-table-dash">
                                            <span className="mdi mdi-clock icon-dash"></span>
                                            {this.changeTimeFormat(item.start_time)} -{" "}
                                            {this.changeTimeFormat(item.end_time)} WIB
                                        </p>
                                    </div>
                                    <div>
                                        <p className="item-table-dash">
                                            <span className="mdi mdi-school icon-dash"></span>
                                            {item.class_label || "-"}
                                        </p>
                                    </div>
                                </td>
                                <td className="text-left">
                                    <div>
                                        <p className="item-table-dash">
                                            <b className="text-danger">{item.is_remedial ? "Remedial" : ""}</b>
                                        </p>
                                    </div>
                                    <div>
                                        <p className="item-table-dash">
                                            <span className="mdi mdi-note icon-dash"></span>Jenis:{" "}
                                            <b>{item.exam_type || "-"}</b>
                                        </p>
                                    </div>
                                    <div>
                                        <p className="item-table-dash">
                                            <span className="mdi mdi-checkbox-marked-circle-outline icon-dash"></span>
                                            Status:
                                            {item.case_name ? (
                                                <label className="badge badge-success ml-1">
                                                    <span
                                                        className="text-black"
                                                        style={{
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            display: "inline-block",
                                                            maxWidth: "180px",
                                                            textOverflow: "ellipsis",
                                                        }}
                                                    >
                                                        {item.case_name}
                                                    </span>
                                                </label>
                                            ) : (
                                                <label className="badge badge-danger ml-1">
                                                    <i>Belum Ada Soal</i>
                                                </label>
                                            )}
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        style={{ width: "100%" }}
                                        className={`btn btn-sm ${item.is_generate
                                                ? "btn-gradient-primary"
                                                : "btn-outline-info"
                                            } btn-icon-text btn-dash-teacher`}
                                        onClick={() =>
                                            this.onClickAccessExam(
                                                item.api_schedule_id,
                                                item.case_id
                                            )
                                        }
                                    >
                                        <i className="mdi mdi-key-variant btn-icon-text"></i>{" "}
                                        Lihat Akses
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {this.state.accessExamModalShow && (
                    <AccessExamModal
                        show={this.state.accessExamModalShow}
                        onHide={accessExamModalClose}
                        apiScheduleId={this.state.selectedScheduleId}
                        idCase={this.state.selectedCaseId}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        finishEdit: state.User.statusEditFinished,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeStatusEdit: (status) => dispatch(changeStatusEdit(status)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessList);
